import classNames from 'classnames';

interface Props {
	tabs: { id: string; label: string }[];
	activeTab: string;
	onChange: (tabId: string) => void;
	className?: string;
}

export default function CrudTabs({ tabs, activeTab, onChange, className = '' }: Props) {
	return (
		<div className={`border-b border-gray-200 bg-white px-8 ${className}`}>
			{/* Scrolls horizontally when the tab set outgrows the viewport (no wrap, no clip). */}
			<nav className="flex -mb-px space-x-8 overflow-x-auto" aria-label="Tabs">
				{tabs.map(tab => (
					<button
						key={tab.id}
						data-test-id={`crud-tab-${tab.id}`}
						onClick={() => onChange(tab.id)}
						className={classNames(
							'whitespace-nowrap border-b-2 py-4 px-1 text-sm font-medium transition-colors',
							{
								'border-[#0ea5e9] text-[#0ea5e9]': activeTab === tab.id,
								'border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700':
									activeTab !== tab.id,
							},
						)}
					>
						{tab.label}
					</button>
				))}
			</nav>
		</div>
	);
}
